import { render, staticRenderFns } from "./chose_spec.vue?vue&type=template&id=ee757298&scoped=true&"
import script from "./chose_spec.vue?vue&type=script&lang=js&"
export * from "./chose_spec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee757298",
  null
  
)

export default component.exports